import { Link } from "react-router-dom";
import { ArrowRight, Flame } from "lucide-react";
import { fileUrl } from "../lib/api";

export function StockBadge({ product }) {
  if (product.status === "sold")
    return <span data-testid="badge-sold" className="inline-flex items-center gap-1.5 rounded-full bg-red-100 px-2.5 py-1 text-xs font-semibold text-red-700"><span className="h-1.5 w-1.5 rounded-full bg-red-500" />Vendu</span>;
  if (product.status === "reserved")
    return <span data-testid="badge-reserved" className="inline-flex items-center gap-1.5 rounded-full bg-amber-100 px-2.5 py-1 text-xs font-semibold text-amber-700"><span className="h-1.5 w-1.5 rounded-full bg-amber-500" />Réservé</span>;
  if (product.out_of_stock)
    return <span data-testid="badge-outofstock" className="inline-flex items-center gap-1.5 rounded-full bg-slate-100 px-2.5 py-1 text-xs font-semibold text-slate-600"><span className="h-1.5 w-1.5 rounded-full bg-slate-400" />Épuisé</span>;
  if (product.low_stock)
    return <span data-testid="badge-lowstock" className="inline-flex items-center gap-1.5 rounded-full bg-amber-100 px-2.5 py-1 text-xs font-semibold text-amber-700"><Flame className="h-3 w-3" />Dernière pièce</span>;
  return <span data-testid="badge-available" className="inline-flex items-center gap-1.5 rounded-full bg-emerald-100 px-2.5 py-1 text-xs font-semibold text-emerald-700"><span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />Disponible</span>;
}

export default function ProductCard({ product }) {
  const img = product.images?.[0];
  return (
    <Link
      to={`/produit/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="card-oxy group block overflow-hidden"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-slate-100">
        {img ? (
          <img src={fileUrl(img)} alt={product.name} loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        ) : (
          <div className="flex h-full items-center justify-center text-slate-300 text-sm">Photo à venir</div>
        )}
        <div className="absolute left-3 top-3 flex flex-col gap-1.5">
          <StockBadge product={product} />
          {product.demo && (
            <span className="rounded-full bg-ink/80 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-gold">Exemple</span>
          )}
        </div>
        {product.condition && (
          <span className="absolute right-3 top-3 rounded-full bg-white/90 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-slate-700 shadow-sm">
            {product.condition}
          </span>
        )}
      </div>
      <div className="p-4 sm:p-5">
        <p className="text-[11px] uppercase tracking-widest text-gold-dark font-semibold">{product.category}</p>
        <h3 className="mt-1 font-display text-base font-semibold text-slate-900 line-clamp-2">{product.name}</h3>
        <div className="mt-3 flex items-center justify-between">
          <span className="font-display text-xl font-bold text-ink">{product.price} €</span>
          <span className="inline-flex items-center gap-1 text-sm font-semibold text-gold-dark transition-transform duration-300 group-hover:translate-x-1">
            Voir <ArrowRight className="h-4 w-4" />
          </span>
        </div>
      </div>
    </Link>
  );
}
